/* eslint-disable import/prefer-default-export */
import * as moment from 'moment';
import utilityFunctions from './functions';

export function isWithinOneYear(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const oneYearPrior = new Date(moment().subtract(365, 'days').format('YYYY-MM-DD')).getTime();
    return slDate >= oneYearPrior;
  }
  return true;
}

export function isBetweenStartAndEndDate(value, parentVm) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value && parentVm && parentVm.serviceStartDate && parentVm.serviceEndDate) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projStart = new Date(moment(parentVm.serviceStartDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projEnd = new Date(moment(parentVm.serviceEndDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    return slDate >= projStart && slDate <= projEnd;
  }
  return true;
}

export function isNotFutureDate(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const now = new Date().getTime();
    return now >= slDate;
  }
  return true;
}

export function areMinutesGreaterThanZero(value) {
  if (value) {
    return Number(value) > 0;
  }
  return true;
}

export function isValidTime(value) {
  if (!value) {
    return true;
  }

  return moment(value, ['h:mm A', 'H:mm:ss', 'H:mm'], true).isValid();
}

export function isValidMinutes(value, parentVm) {
  if (value) {
    const sessionTime =
      parentVm.sessionTime ? utilityFunctions.convertTimeToMinutes(parentVm.sessionTime, true) : null;
    const maxMinutes = 1440 - sessionTime;
    // make sure that the number is an integer
    return Number.isInteger(Number(value)) && (Number(value) <= 1440) && (maxMinutes >= value);
  }
  return true;
}

export function isSessionTimeEndGreaterThanSessionTime(value, parentVm) {
  if (value && parentVm && parentVm.sessionTime) {
    const startMil = utilityFunctions.calculateMilitaryTime(parentVm.sessionTime, true);
    const startTime = utilityFunctions.convertTimeToMinutes(startMil, true);
    const endMil = utilityFunctions.calculateMilitaryTime(value, false);
    if (startTime) {
      return utilityFunctions.convertTimeToMinutes(endMil, false) > startTime;
    }
  }
  return true;
}

export function isEndTimeEndGreaterThanStartTime(value, parentVm) {
  if (value && parentVm && parentVm.startTime) {
    const startMil = utilityFunctions.calculateMilitaryTime(parentVm.startTime, true);
    const startTime = utilityFunctions.convertTimeToMinutes(startMil, true);
    const endMil = utilityFunctions.calculateMilitaryTime(value, false);
    if (startTime) {
      return utilityFunctions.convertTimeToMinutes(endMil, false) > startTime;
    }
  }
  return true;
}

// Declared as a regular function (not an arrow function) so Vuelidate binds `this` to the
// root component (see vuelidate's rootModel), giving access to serviceInformation.sessionTime,
// which lives outside the medicaid.$each record this validator runs on.
export function isProcedureStartTimeWithinSession(value) {
  const serviceInformation = this && this.student && this.student.form.serviceInformation;
  const sessionTime = serviceInformation && serviceInformation.sessionTime;
  if (value && sessionTime) {
    const sessionStartMil = utilityFunctions.calculateMilitaryTime(sessionTime, true);
    const sessionStart = utilityFunctions.convertTimeToMinutes(sessionStartMil, true);
    const valueMil = utilityFunctions.calculateMilitaryTime(value, true);
    const valueMinutes = utilityFunctions.convertTimeToMinutes(valueMil, true);
    if (valueMinutes < sessionStart) return false;

    const sessionTimeEnd = serviceInformation.sessionTimeEnd;
    if (sessionTimeEnd) {
      const sessionEndMil = utilityFunctions.calculateMilitaryTime(sessionTimeEnd, false);
      const sessionEnd = utilityFunctions.convertTimeToMinutes(sessionEndMil, false);
      // Start Time must be strictly before Session End - if they're equal there's no
      // room left in the session for the procedure to have a positive duration.
      if (valueMinutes >= sessionEnd) return false;
    }
  }
  return true;
}

// See isProcedureStartTimeWithinSession for why this relies on `this` rather than parentVm.
export function isProcedureEndTimeWithinSession(value) {
  const serviceInformation = this && this.student && this.student.form.serviceInformation;
  const sessionTimeEnd = serviceInformation && serviceInformation.sessionTimeEnd;
  if (value && sessionTimeEnd) {
    const sessionEndMil = utilityFunctions.calculateMilitaryTime(sessionTimeEnd, false);
    const sessionEnd = utilityFunctions.convertTimeToMinutes(sessionEndMil, false);
    const valueMil = utilityFunctions.calculateMilitaryTime(value, false);
    const valueMinutes = utilityFunctions.convertTimeToMinutes(valueMil, false);
    if (valueMinutes > sessionEnd) return false;

    const sessionTime = serviceInformation.sessionTime;
    if (sessionTime) {
      const sessionStartMil = utilityFunctions.calculateMilitaryTime(sessionTime, true);
      const sessionStart = utilityFunctions.convertTimeToMinutes(sessionStartMil, true);
      // End Time must be strictly after Session Start - if they're equal there's no
      // room left in the session for the procedure to have a positive duration.
      if (valueMinutes <= sessionStart) return false;
    }
  }
  return true;
}

export function isTotalMedicaidMinutesValid(value, parentVm) {
  if (value && parentVm && parentVm.serviceInformation.sessionMinutes) {
    const sessionMinutes = parentVm.serviceInformation.sessionMinutes;
    if (value > sessionMinutes) {
      return false;
    }
  }
  return true;
}

export function isTotalReimbursableMinutesValid(value, parentVm) {
  if (value && parentVm && parentVm.serviceInformation.sessionMinutes) {
    const sessionMinutes = parentVm.serviceInformation.sessionMinutes;
    if (sessionMinutes) {
      return sessionMinutes >= value;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/validations.js